import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { schedulePublicApi } from "@/api/scheduling/schedule-public.api";

export const publicBookingStore = configureStore({
  reducer: {
    [schedulePublicApi.reducerPath]: schedulePublicApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(schedulePublicApi.middleware),
  devTools: import.meta.env.DEV,
});

setupListeners(publicBookingStore.dispatch);

export type PublicBookingRootState = ReturnType<
  typeof publicBookingStore.getState
>;
export type PublicBookingDispatch = typeof publicBookingStore.dispatch;
